module.exports = __webpack_public_path__ + "static/media/source-sans-pro-regular.1d714384.eot";